import { useMutation, useQuery } from '@tanstack/react-query';
import { queryClient } from '@/config/reactQuery';
import { QUERY_KEYS } from '../../queryKeys';
import { documentManagement } from '../DocumentManagement';

export const useDocuments = () =>
  useQuery({
    queryKey: [QUERY_KEYS.documentManagementDocument],
    queryFn: async () => (await documentManagement.getDocuments()).data,
  });

export const useUploadDocument = () =>
  useMutation({
    mutationFn: documentManagement.uploadDocument,
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.documentManagementDocument],
      }),
  });

export const useDeleteDocument = () =>
  useMutation({
    mutationFn: documentManagement.deleteDocument,
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.documentManagementDocument],
      }),
  });
